module.exports = __webpack_public_path__ + "img/rightthigh-mesomorph-male.1aa76d2f.svg";